export function NormalSample() {
  return (
    <svg
      width="19"
      height="24"
      viewBox="0 0 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.46875 2.50078C0.46875 1.28575 1.45372 0.300781 2.66875 0.300781H16.6688C17.8838 0.300781 18.8688 1.28575 18.8688 2.50078C18.8688 3.71581 17.8838 4.70078 16.6688 4.70078H15.8687V17.5008C15.8687 20.9249 13.0929 23.7008 9.66875 23.7008C6.24458 23.7008 3.46875 20.9249 3.46875 17.5008V4.70078H2.66875C1.45372 4.70078 0.46875 3.71581 0.46875 2.50078ZM5.86875 4.70078V10.0008H13.4688V4.70078H5.86875ZM5.86875 17.5008V16.0008H13.4688V17.5008C13.4688 19.5995 11.7674 21.3008 9.66875 21.3008C7.57007 21.3008 5.86875 19.5995 5.86875 17.5008ZM6.6687 12.0008C6.6687 11.7246 6.89256 11.5008 7.1687 11.5008H10.1687C10.4448 11.5008 10.6687 11.7246 10.6687 12.0008C10.6687 12.2769 10.4448 12.5008 10.1687 12.5008H7.1687C6.89256 12.5008 6.6687 12.2769 6.6687 12.0008ZM7.1687 13.5008C6.89256 13.5008 6.6687 13.7246 6.6687 14.0008C6.6687 14.2769 6.89256 14.5008 7.1687 14.5008H12.1687C12.4448 14.5008 12.6687 14.2769 12.6687 14.0008C12.6687 13.7246 12.4448 13.5008 12.1687 13.5008H7.1687Z"
        fill="#007AE7"
      />
    </svg>
  );
}
